import Vue from 'vue';

Vue.component('error', {
    template: `<transition name="slide-fade"><span class="error-message"><slot></slot></span></transition>`,
});



// WEBPACK FOOTER //
// ./Content/js/app/components/vc-error.js